import { Link } from '@tanstack/react-router';

import { Button } from '@/components/ui/button';
import { ApiError } from '@/lib/api/errors';

/*
 * Global error component (spec §4.2). Renders ApiError specifics when present.
 */
export function RouteError({ error }: { error: unknown }) {
  const message =
    error instanceof ApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : 'An unexpected error occurred.';

  return (
    <div className="mx-auto flex max-w-md flex-col items-center gap-4 p-12 text-center">
      <h1 className="text-xl font-semibold">Something went wrong</h1>
      <p className="text-sm text-muted-foreground">{message}</p>
      <Button render={<Link to="/">Back to home</Link>} />
    </div>
  );
}
